import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';

@Component({
    selector: 'sp-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit, OnChanges {
    @Input()
    totalRecords: number;

    @Input()
    totalPages: number;

    @Output()
    onPageChange: EventEmitter<{ page: number; pageSize: number }> =
        new EventEmitter(true);

    @Input()
    recordType?: string;

    @Input()
    currentPage: number = 1;

    @Input() pageSize: number = 10;
    pageList = [];
    constructor() {
        this.pageListCalculation(1);
    }
    ngOnChanges(changes: SimpleChanges): void {
        this.pageListCalculation(this.currentPage);
    }

    ngOnInit(): void {
        this.pageListCalculation(this.currentPage);
    }

    previousPage() {
      if(this.currentPage == 1){
        return;
      }
      this.pageListCalculation(this.currentPage);
        this.currentPage -= 1;
        this.onPageChange.emit({
            page: this.currentPage,
            pageSize: this.pageSize,
        });
    }

    pageSelect(page) {
        this.currentPage = page;
        this.onPageChange.emit({
            page: this.currentPage,
            pageSize: this.pageSize,
        });
    }
    nextPage() {
      if(this.currentPage >= this.totalPages){
        return;
      }
      this.pageListCalculation(this.currentPage);
        this.currentPage += 1;
        this.onPageChange.emit({
            page: this.currentPage,
            pageSize: this.pageSize,
        });
    }

    changePageSizeEvent(page) {
        this.currentPage = 1;
        this.pageSize = page;
        this.onPageChange.emit({
            page: this.currentPage,
            pageSize: this.pageSize,
        });
        // this.pageListCalculation(this.currentPage);
    }

    pageListCalculation(currentPage) {
        let totalPage = this.totalPages;

        let pageThreshold = 5;

        if (this.totalPages < 5) {
            pageThreshold = this.totalPages;

            this.pageList = [];

            for (let i = 0; i < this.totalPages; i++) {
                this.pageList[i] = i + 1;
            }

            return;
        }

        let floor = Math.floor(pageThreshold / 2);

        if (currentPage === 1) {
            this.pageList = [...Array(pageThreshold).keys()].map(
                (a) => a + currentPage
            );
        } else if (currentPage - floor >= 1) {
            this.pageList = [];

            let firstPage = currentPage - floor;

            if (currentPage + floor > totalPage) {
                console.log(currentPage + floor - totalPage);

                firstPage = firstPage - (currentPage + floor - totalPage);
            }

            for (let i = 0; i < pageThreshold; i++) {
                if (firstPage + i <= totalPage) {
                    this.pageList[i] = i + firstPage;
                }
            }
        } else if (currentPage - (floor - 1) >= 1) {
            this.pageList = [];

            let firstPage = currentPage - (floor - 1);

            for (let i = 0; i < pageThreshold; i++) {
                if (firstPage + i <= totalPage) {
                    this.pageList[i] = i + firstPage;
                }
            }
        }
    }
}
